import React from "react";
import AndroidDownloadButton from "../components/ui/AndroidDownloadButton";
import IOSDownloadButton from "../components/ui/IOSDownloadButton";
import { getProductShareInfo } from "../api/products";
import { useParams } from "react-router-dom";

export default function ProductSharePage() {
  const { name } = useParams();
  //   console.log(name);
  const appInfo = getProductShareInfo(name);

  return (
    <div className="w-full h-full justify-center items-center center flex flex-col gap-4">
      <img
        className="rounded-full mb-4 w-60 h-60"
        src={`../../products_logos/${appInfo.logo}`}
        alt=""
      />
      <p className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-800 md:text-5xl lg:text-6xl ">
        {appInfo.title}
      </p>
      <p className="mb-6 text-xl  text-gray-600 lg:text-xl sm:px-16 xl:px-48 ">
        {appInfo.desc}
      </p>
      <div className="flex flex-col gap-4">
        <AndroidDownloadButton url={appInfo.android} />
        <IOSDownloadButton url={appInfo.ios} />
      </div>
    </div>
  );
}
